import { useSettingsQuery } from 'src/api/queries/userQueries';
import { PageBody, SaveChangesBar, SettingsNavigation } from 'src/components';
import DefaultUploadSchemaSetting from 'src/components/DefaultUploadSchemaSetting';

import styles from './styles.module.scss';

export const MetadataSettings = () => {
  const { isLoading } = useSettingsQuery();

  if (isLoading) {
    return null;
  }

  return (
    <div className={styles.pageWrapper}>
      <SettingsNavigation />
      <SaveChangesBar />

      <PageBody narrow>
        <DefaultUploadSchemaSetting />
      </PageBody>
    </div>
  );
};
